import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class DeleteInvestment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeleteModalShow: false
    };
  }

  handleDeleteModal = () => {
    this.setState(prevState => (
      { isDeleteModalShow: !prevState.isDeleteModalShow }
    ));
  };

  handleDeleteButtonClick = (event) => {
    event.preventDefault();
    const { company, actions } = this.props;
    actions.deleteInvestment(company.investment_id);
  }

  render () {
    const { isDeleteModalShow } = this.state;
    const { is_mypage, isEditMode, company } = this.props;

    return is_mypage === true && isEditMode === true && (
      <React.Fragment>
        <button type='button' className='btn-profile-edit float-none' onClick={this.handleDeleteModal}>
          <i className='fas fa-trash' />
        </button>

        <Modal isOpen={isDeleteModalShow} toggle={this.handleDeleteModal}>
          <ModalHeader toggle={this.handleDeleteModal}>投資先の削除</ModalHeader>
          <ModalBody>
            投資先
            {" "}
            {company.name}
            {" "}
を削除しますか？
          </ModalBody>
          <ModalFooter>
            <Button color="outline-primary" onClick={this.handleDeleteModal}>キャンセル</Button>
            {" "}
            <Button color="primary" onClick={this.handleDeleteButtonClick}>削除する</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

DeleteInvestment.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo_image: PropTypes.string,
    website_url: PropTypes.string
  }).isRequired,
  is_mypage: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool,
  actions: PropTypes.objectOf(PropTypes.func).isRequired
};

DeleteInvestment.defaultProps = {
  isEditMode: false
};

export default DeleteInvestment;
